import { render, staticRenderFns } from "./RoundStartButton.vue?vue&type=template&id=b42dd3dc&scoped=true&"
import script from "./RoundStartButton.vue?vue&type=script&lang=js&"
export * from "./RoundStartButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundStartButton.vue?vue&type=style&index=0&id=b42dd3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42dd3dc",
  null
  
)

export default component.exports